
<template>
  <el-container class="errorIndex">
      <el-main class="flex_justify_center">
          <p class="font_24_bold color_black">An error occurred.<br /> Please try again.</p>
      </el-main>
  </el-container>
</template>
<script>
import IndexHeader from './views/header'
export default {
  components: {
    IndexHeader
  },
  created () {
    if (!this.utils.getCookie('pc_token')) {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .errorIndex{
    height: 100%;
    .el-header{
      height: 118px!important;
      background: rgba(53,54,67,0.90);
      width: 100%;
      padding:0;
    }
    .el-main{
      flex-direction: column;
      p{
        margin-bottom:55px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/error.vue